<template lang="pug">
#joystick.joystick
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";

import nipplejs from 'nipplejs';
let manager;

export default {
  methods: {
    // 漫游摇杆
    activeJoyStickPanel(flag) {
      if (flag) {
        mongeApiMlib.JoyStickerActive();
        manager = nipplejs.create({
          zone: document.getElementById("joystick"),
          mode: "static", //
          position: { left: "50px", top: "50px" },
          color: "#1C83FE",
          size: 150
        });
        const joystick = manager[0];
        joystick
          .on("move", function (evt, data) {
            // angle取值为摇杆推动方向与摇杆正上方方向逆时针夹角（0~360）
            const angle = data.angle.radian - Math.PI / 2;
            // 推动力度
            const force = data.distance * 0.004;
            mongeApiMlib.JoyStickerWalk(force, angle);
          })
          .on("start", function (evt, data) {
            mongeApiMlib.JoyStickerStart();
          })
          .on("end", function (evt, data) {
            mongeApiMlib.JoyStickerEndWalk();
          });
      } else {
        // Monge.Model.JoyStick.deactive()
        manager.destroy();
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.joystick {
  position: fixed;
  left: 40px;
  bottom: 190px;

  /deep/ .back {
    // background-image: url("../../images/modelImage/direction.png") !important;
    background-size: contain !important;
  }
}
</style>
